import axios from 'axios';
import Vue from 'vue';

const service = axios.create({
  noMessageAlert: false,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    Client: 'web',
  },
  baseURL: '',
});

service.interceptors.response.use(response => Promise.resolve(response), (error) => {
  console.error(error);
  const response = error.response
  Vue.$vux.alert.show({
    type: 'cancel',
    content: response.data || '请求失败',
  });
  Promise.reject(error);
});

service.GET = (url, params, showLoading) =>
  service.get(url, { params, showLoading: showLoading || false });

service.POST = (url, params, showLoading) => {
  const config = {
    showLoading: showLoading || false,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return service.post(url, params, config);
};

service.POSTForm = (url, params, showLoading) => {
  const config = {
    showLoading: showLoading || false,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
  };
  let sData = '';
  for (const k in params) {
    if (params.hasOwnProperty(k)) {
      sData += `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}&`;
    }
  }
  return service.post(url, sData, config);
};

export default service;



// WEBPACK FOOTER //
// ./src/api/axios.js